import React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "../../../lib/utils";
import { PORTAL_SURFACE } from "./classes";

/** A small anchored panel (Log interaction, stage override, filter choices, date picker). */
export default function CrmPopover({ open, onOpenChange, trigger, children, align = "start", className, testId }) {
  return (
    <PopoverPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <PopoverPrimitive.Trigger asChild>{trigger}</PopoverPrimitive.Trigger>
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          align={align}
          sideOffset={6}
          collisionPadding={12}
          data-testid={testId}
          data-lenis-prevent
          className={cn(PORTAL_SURFACE, "z-50 w-[min(22rem,calc(100vw-1.5rem))] rounded-2xl p-4 outline-none", className)}
        >
          {children}
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  );
}
